import { useState } from "react";
import EditHeadingModal from "../heading/EditHeadingModal";
import AppButton from "../../common/AppButton";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Button,
} from "@heroui/react";
import { SquarePen, Plus, MoreVertical } from 'lucide-react'


export default function IndicatorSection({ section, sessionId, setNewTimeSetted, sectionTime, formatTime, setIsAddSectionModalOpen }) {  

    const [isModalOpen, setIsModalOpen] = useState(false);
    

    return (
        <div className="px-0 flex items-center">
            <Dropdown className="text-onSurface bg-surfaceContainer p-0 border-0">
                <DropdownTrigger>
                    <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();     // Prevent accordion toggle
                        e.preventDefault();      // Prevent default behavior that may interfere
                    }}
                    className="h-8 w-8 hover:bg-surfaceContainer bg-surface rounded-full p-0 me-2.5 z-20 flex items-center justify-center text-black"
                    >
                    <MoreVertical className="w-5 h-5 rounded-xl" />
                    </button>
                </DropdownTrigger>

                <DropdownMenu
                    className="p-0"
                    aria-label="Project actions"
                    onAction={(key) => {
                    if (key === "edit") setIsModalOpen(true);
                    if (key === "addSection") setIsAddSectionModalOpen(true);
                    }}
                >
                    <DropdownItem
                    key="edit"
                    startContent={<SquarePen className="w-4 h-4" />}
                    className="text-sm p-4 py-3 rounded-xl hover:bg-secondaryContainer"
                    textValue="Edit section heading"
                    >
                    Edit
                    </DropdownItem>
                    <DropdownItem
                    key="addSection"
                    startContent={<Plus className="w-4 h-4" />}
                    className="text-sm p-4 py-3 rounded-xl hover:bg-secondaryContainer"
                    textValue="Add section"
                    >
                        Add section
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>

            <EditHeadingModal
                heading={section}
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                sessionId={sessionId}
            />
            <button
                onClick={() => setNewTimeSetted(sectionTime)}
                className="text-base hover:underline cursor-pointer w-20"
            >
                {formatTime(sectionTime)}
            </button>
        </div>
  );
}
